import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// =============================================================================
// Per-task manual line items (svc-06, /v1/tasks/:id/manual-line-items).
// Mirrors packages/shared-types/src/svc-06-quotation/v1/manual-line-item.schema.ts.
// Money on the wire is a Decimal-precision string (rule §D.12).
// =============================================================================

export interface ManualLineItem {
  itemId: string;
  taskId: string;
  isManual: boolean | null;
  partNo: string | null;
  description: string | null;
  category: string | null;
  toolingType: string | null;
  machineType: string | null;
  itemName: string | null;
  partName: string | null;
  currency: string | null;
  price: string | null;
  qty: number | null;
  autoApproved: boolean;
  createdByEmail: string | null;
  createdByName: string | null;
  createdByRole: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ManualLineItemInput {
  description: string;
  price: string;
  qty: number;
  currency: string;
  isManual?: boolean;
  partNo?: string | null;
  category?: string | null;
  toolingType?: string | null;
  machineType?: string | null;
  itemName?: string | null;
  partName?: string | null;
}

/** GET /v1/tasks/:taskId/manual-line-items. */
export async function listManualLineItems(taskId: string): Promise<ManualLineItem[]> {
  const res = await Api.get(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items`,
  );
  return unwrap<{ items: ManualLineItem[] }>(res.data).items;
}

/** POST /v1/tasks/:taskId/manual-line-items. */
export async function addManualLineItem(
  taskId: string,
  body: ManualLineItemInput,
): Promise<ManualLineItem> {
  const res = await Api.post(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items`,
    body,
  );
  return unwrap<ManualLineItem>(res.data);
}

/** DELETE /v1/tasks/:taskId/manual-line-items/:itemId. */
export async function deleteManualLineItem(
  taskId: string,
  itemId: string,
): Promise<void> {
  await Api.delete(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items/${encodeURIComponent(itemId)}`,
  );
}
